import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "style", "tips"],
        },
        controller: {
            label: "控制属性",
            keys: ["align", "expand"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        style: Object.assign({}, baseAttribute.style),
        align: {
            inputMethod: ControlAttributeType.Dropdown,
            value: "left",
            options: {
                list: [
                    {
                        value: "left",
                        label: "左",
                    },
                    {
                        value: "center",
                        label: "中",
                    },
                    {
                        value: "right",
                        label: "右",
                    },
                ],
            },
        },
    },
};
